import { LucideIcon, Lock } from 'lucide-react';

interface FeatureTeaserProps {
  title: string;
  description: string;
  icon: LucideIcon;
  buttonText: string;
  onClick: () => void;
  locked?: boolean;
  planName?: string;
}

export function FeatureTeaser({
  title,
  description,
  icon: Icon,
  buttonText,
  onClick,
  locked = false,
  planName
}: FeatureTeaserProps) {
  return (
    <div className="bg-gradient-to-br from-blue-50 to-cyan-50 rounded-lg p-6 border-2 border-blue-200 relative overflow-hidden">
      {locked && (
        <div className="absolute top-3 right-3">
          <div className="bg-blue-600 text-white p-2 rounded-lg">
            <Lock size={16} />
          </div>
        </div>
      )}

      <div className="flex items-start gap-4 mb-4">
        <div className="flex-shrink-0 p-3 bg-white rounded-lg shadow-sm">
          <Icon size={28} className="text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-gray-900 mb-1">{title}</h3>
          {planName && (
            <span className="inline-block px-2 py-0.5 bg-blue-600 text-white text-xs font-semibold rounded mb-2">
              Plan {planName}
            </span>
          )}
        </div>
      </div>

      <p className="text-sm text-gray-700 mb-4 leading-relaxed">{description}</p>

      <button
        onClick={onClick}
        className="w-full px-4 py-3 bg-blue-600 text-white rounded-lg font-semibold hover:bg-blue-700 transition-colors shadow-sm"
      >
        {buttonText}
      </button>
    </div>
  );
}
